
import { ScoreDisplayProps } from "./types";
import { getScoreColorClass } from "@/utils/score-utils";

export function ScoreDisplay({ score, total, className }: ScoreDisplayProps) {
  const percentage = total > 0 ? Math.round((score / total) * 100) : 0;
  const colorClass = getScoreColorClass(percentage);
  
  return (
    <span className={`font-medium ${colorClass} ${className || ""}`}>
      {score} / {total} ({percentage}%)
    </span>
  );
}
